import {
	FieldConfiguration,
	GroupFieldConfiguration,
} from '../../../api/ConfigApi';

const flattenObjectByName = (fields: FieldConfiguration[], name: string) => {
	return fields.reduce((obj: { [key: string]: FieldConfiguration }, item) => {
		if (item.name) {
			obj[name + '.' + item.name] = item;
		}
		if ((item as GroupFieldConfiguration).fields) {
			obj = {
				...obj,
				...flattenObjectByName(
					(item as GroupFieldConfiguration).fields,
					name + '.' + item.name,
				),
			};
		}
		return obj;
	}, {});
};

export default flattenObjectByName;
